import React, { ReactElement, ReactNode, useEffect, useState } from 'react';
import { Button, TimePicker, Tooltip } from 'antd';
import { getTimeFromSecondsOrMinutes } from '../../../utils/utility';
import moment, { Moment } from 'moment';
import { Week } from '../../../shared/models/inventory.model';
import { UPC_TIME_FORMAT } from '../../../shared/constants/commonConstants';
import { Slots } from './../../../shared/models/inventory.model';
import _ from 'lodash';
import { ReactComponent as CloseIcon } from '../../../assets/images/svg/i_close.svg';
import { ReactComponent as CopyAllIcon } from '../../../assets/images/svg/i_copy_all.svg';
import { ReactComponent as AddIcon } from '../../../assets/images/svg/i_add.svg';

const SmallCalendar = ({ direction, slots, onChangeSlots, isReadOnly }: any): ReactElement => {
  const { RangePicker } = TimePicker;
  const week: Week[] = [
    { name: 'M', isActive: false, value: 'Monday' },
    { name: 'T', isActive: false, value: 'Tuesday' },
    { name: 'W', isActive: false, value: 'Wednesday' },
    { name: 'T', isActive: false, value: 'Thursday' },
    { name: 'F', isActive: false, value: 'Friday' },
    { name: 'S', isActive: false, value: 'Saturday' },
    { name: 'S', isActive: false, value: 'Sunday' },
  ];

  const [weekDays, setWeekDays] = useState(null as any);

  useEffect((): void => {
    if (slots && slots.length > 0) {
      week.forEach((v: Week): void => {
        let slot: any;
        if (slots.findIndex((vv: any): any => { slot = vv; return vv.dayOfWeek === v.value; }) !== -1) {
          v.isActive = true;
          v.start = getTimeFromSecondsOrMinutes(slot?.slots[0]?.startTime || 0, 'minutes');
          v.end = getTimeFromSecondsOrMinutes(slot?.slots[0]?.endTime || 0, 'minutes');
          v.slotsRanges = getDeafultSlotsRanges(v.start, v.end, slot.slots);
        } else {
          v.isActive = false;
        }
      });
    } else {
      week.forEach((v: Week): void => {
        v.isActive = false;
      });
    }
    setWeekDays([...week]);
  }, [slots]);

  useEffect((): void => {
    if (weekDays && onChangeSlots) {
      onChangeSlots(weekDays);
    }
  }, [weekDays]);

  const getDeafultSlotsRanges = (start?: any, end?: any, slot?: Slots[]): any => {
    const range = [];
    if (slot && slot.length > 1) {
      slot.map((v: Slots): any => {
        range.push(
          [
            moment(getTimeFromSecondsOrMinutes(v.startTime, 'minutes'), UPC_TIME_FORMAT),
            moment(getTimeFromSecondsOrMinutes(v.endTime, 'minutes'), UPC_TIME_FORMAT),
          ],
        );
      });
    } else {
      range.push([moment(start ? start : '12:00 am', UPC_TIME_FORMAT), moment(end ? end : '12:30 am', UPC_TIME_FORMAT)]);
    }
    return range;
  };

  const onSlotsChange = (e: Moment | any, day: Week, index?: number): void => {
    const w = _.cloneDeep(weekDays);
    w.forEach((v: Week): any => {
      if (v.value === day.value) {
        const t = v?.slotsRanges ? [...v.slotsRanges] : [];
        if (index || index === 0) {
          if (e) {
            t.splice(index, 1, [moment(e[0]?._d, UPC_TIME_FORMAT), moment(e[1]?._d, UPC_TIME_FORMAT)]);
          } else {
            t.splice(index, 1);
          }
          v.slotsRanges = [...t];
        } else {
          v.start = e[0]._d;
          v.end = e[1]._d;
          v.slotsRanges = getDeafultSlotsRanges(e[0]._d, e[1]._d);
        }
      }
    });
    setWeekDays(w);
  };

  const onAddSlot = (day: Week): void => {
    const w = [...weekDays];
    w.forEach((v: Week): void => {
      if (v.value === day.value) {
        const newSlot = getDeafultSlotsRanges();
        v.slotsRanges = [...v.slotsRanges, ...newSlot];
      }
    });
    setWeekDays([...w]);
  };

  const onCopySlots = (day: Week): void => {
    const slotsToCopy: Week[] = [...weekDays.filter((v: Week): boolean => v.value === day.value)];
    const w = [...weekDays];
    w.forEach((v: Week): void => {
      v.start = slotsToCopy[0].start;
      v.end = slotsToCopy[0].end;
      v.slotsRanges = slotsToCopy[0].slotsRanges;
    });
    setWeekDays([...w]);
  };

  return (
    <>
      <div className="sm-cal-list" style={{ flexDirection: direction }}>
        {weekDays && weekDays.length > 0 && weekDays.map((day: Week, index: number): ReactNode => (
          <div key={index + day.value}>
            {direction ? (
              <div key={index + day.name} className="sm-cal-slots-range">
                <Button type="primary" ghost={day.isActive ? false : true}
                  icon={day.name} key={day.name + index} className="mr-10" />
                {(direction && direction === 'column') && (
                  <div style={{ display: 'flex', flexDirection: 'column', position: 'relative', justifyContent: 'center' }}>
                    {(day.slotsRanges && day.slotsRanges.length > 0) ? day.slotsRanges.map((v: any, i: number, a: any): ReactNode => {
                      return (
                        <div key={i + v}>
                          <RangePicker
                            disabled={isReadOnly} key={i}
                            className="picker-has-data" format={UPC_TIME_FORMAT} allowClear={false} bordered={false}
                            onChange={(e: any): void => onSlotsChange(e, day, i)} value={v} placeholder={['Start time', 'End time']}
                            size={'small'} />
                          {!isReadOnly &&
                            <Tooltip title="Clear slot">
                              <CloseIcon className="mouse-pointer fill-close" onClick={(): void => onSlotsChange(null, day, i)} />
                            </Tooltip>
                          }
                        </div>
                      );
                    }) : (
                        <>
                          <RangePicker disabled={isReadOnly} format={UPC_TIME_FORMAT} allowClear={false} bordered={false}
                            onChange={(e: any): void => onSlotsChange(e, day)}
                            size={'small'} />
                        </>
                      )}
                    {(day.start && day.slotsRanges && day.slotsRanges.length > 0) && (
                      <>
                        {!isReadOnly &&
                          <Tooltip title="Copy to all">
                            <CopyAllIcon className="fill-primary mouse-pointer"
                             style={{ position: 'absolute', right: '-11%', top: '5px', fontSize: '12px' }}
                            onClick={(): void => onCopySlots(day)} />
                          </Tooltip>
                        }
                        {!isReadOnly &&
                          <Tooltip title="Add slot">
                            <AddIcon className="fill-primary mouse-pointer"
                            style={{ position: 'absolute', right: '-22%', top: '5px', fontSize: '14px' }}
                            onClick={(): void => onAddSlot(day)} />
                          </Tooltip>
                        }
                      </>
                    )}
                  </div>
                )}
              </div>
            ) : (
                <Button disabled={!day.isActive} icon={day.name} key={day.name + index} />
              )}
          </div>
        ))}
      </div>
    </>
  );
};

export default SmallCalendar;
